(function () {
    'use strict';

    angular
        .module('actionPlanModule')
        .controller('grcActionPlanCommentsModalController', Controller);

    Controller.$inject = ['$scope', 'grcActionPlanService'];

    function Controller($scope, grcActionPlanService) {

        $scope.ctrlCtxt = {
            isLoading: true
        };

        // Get assessments
        grcActionPlanService
            .getAllActionPlanAssessments($scope.actionPlan.ActionPlanID)
            .then(function (assessments) {
                $scope.actionPlanAssessments = assessments;
            })
            .finally(function () {
                $scope.ctrlCtxt.isLoading = false;
            })
    }
})();